import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
const AssignAgentList = ({ show, hide, title, messages }) => {
  const [userState, setUserState] = useState([]);
  const updateAgentsInState = (messages = []) => {
    const uniqueAgents = Array.from(
      new Map(
        messages
          .filter(item => item.userType === "agent")
          .map(item => [
            item.userId,
            {
              userName: item.userName,
              userIcon: item.userIcon,
              userId: item.userId,
            },
          ])
      ).values()
    );
    setUserState(uniqueAgents);
  };

  useEffect(() => {
    updateAgentsInState(messages)
  }, [messages]);

  return (
    <Modal show={show} onHide={hide}>
      <Modal.Header closeButton className="p-3">
        <Modal.Title style={{ fontSize: 15 }}>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="preview-scroll p-0">
          {userState?.map((item, index) => (
            <div key={index} className="hstack gap-2 py-1">
              <span className="text-muted">{index+1}.</span>
              <span className="fw-medium text-end">
                <div
                  className="d-flex align-items-center gap-2"
                >
                  <img
                    src={item?.userIcon}
                    alt={item?.userName}
                    style={{
                      width: 20,
                      height: 20,
                      borderRadius: "100%"
                    }}
                  />
                  <div>
                    <div className="fw-medium">{item?.userName}</div>
                  </div>
                </div>
              </span>
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AssignAgentList;
